import { render, staticRenderFns } from "./reservationRecord.vue?vue&type=template&id=f955f338&scoped=true&"
import script from "./reservationRecord.vue?vue&type=script&lang=js&"
export * from "./reservationRecord.vue?vue&type=script&lang=js&"
import style0 from "./reservationRecord.vue?vue&type=style&index=0&id=f955f338&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f955f338",
  null
  
)

export default component.exports